module.exports = __webpack_public_path__ + "media/images/icon-svg/check-74900aa5e4b46eac380901f1626202df.svg";